/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 * @dependencies gumshoe.js
 */

import Headroom from 'headroom.js';
import Gumshoe from 'gumshoejs';

const sizeChangeEvents = ['resize', 'orientationchange'];

// Header Element
const navEl = document.querySelector('.js-fixed-nav');
const topBarEl = document.querySelector('.js-topbar');
const residenceNav = document.querySelector('.js-residence-nav');

if (navEl) {
  let navHeight = navEl.offsetHeight;
  let topBarHeight = topBarEl ? topBarEl.offsetHeight : '';
  let windowHeight = window.innerHeight;
  let windowWidth = window.innerWidth;

  const residenceNavObsCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.boundingClientRect.top <= 46 && !entry.isIntersecting && residenceNav.offsetHeight !== 0) {
        entry.target.classList.add('sticky');
        fixedNav.freeze();
      } else {
        entry.target.classList.remove('sticky');
        fixedNav.unfreeze();
      }
    })
  }

  const residenceNavObs = new IntersectionObserver(residenceNavObsCallback, {
    rootMargin: `-46px 0px 0px 0px`,
    threshold: 1,
  });

  const residenceNavLinks = residenceNav ? Array.from(residenceNav.getElementsByClassName('residence-nav__menu__link')) : '';
  const lastSectionID = residenceNav ? residenceNavLinks[residenceNavLinks.length - 1].hash : '';
  const lastVisibleSection = residenceNav ? document.querySelector(lastSectionID) : '';

  const lastSectionObs = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0 && windowWidth >= 1024) {
      residenceNav.classList.remove('sticky');
      fixedNav.unfreeze();
    }
    if (entries[0].isIntersecting && !residenceNav.classList.contains('sticky') && windowWidth >= 1024) {
      residenceNav.classList.add('sticky');
      fixedNav.freeze();
    }
  }, {
    rootMargin: `-46px 0px 0px 0px`,
    threshold: 0.5,
  });

  const calcHeaderHeight = () => {
    navHeight = navEl.offsetHeight;
    topBarHeight = topBarEl ? topBarEl.offsetHeight : '';
    windowHeight = window.innerHeight;
    windowWidth = window.innerWidth;

    if (topBarEl) {
      document.documentElement.style.setProperty('--baseline-height', `${topBarHeight}px`);
    }
    document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);

    if (residenceNav) {
      if (windowWidth >= 1024 && !residenceNavObs.takeRecords().length) {
        residenceNavObs.observe(residenceNav);
      } else {
        residenceNavObs.unobserve(residenceNav);
      }
    }
  }

  const fixedNav = new Headroom(navEl, {
    offset: topBarHeight,
    classes: {
      // when element is initialised
      initial: "initialized",
      // when scrolling up
      pinned: "is-pinned",
      // when scrolling down
      unpinned: "is-unpinned",
      // when above offset
      top: "is-top",
      // when below offset
      notTop: "is-not-top",
      // when at bottom of scoll area
      bottom: "is-bottom",
      // when not at bottom of scroll area
      notBottom: "is-not-bottom"
    }
  });

  window.addEventListener('load', function() {
    fixedNav.init();
    calcHeaderHeight();

    sizeChangeEvents.forEach((event) => {
      window.addEventListener(event, debounce(calcHeaderHeight));
    });
  });

  if (residenceNav && windowWidth >= 1024) {
    residenceNavObs.observe(residenceNav);
    const scrollSpyNav = new Gumshoe('.js-scrollspy-menu a', {
      navClass: 'residence-nav__menu__item--active',
      offset: windowHeight * 0.25,
      reflow: false,
    });

    lastSectionObs.observe(lastVisibleSection);
  }
}


// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
